// extracted by mini-css-extract-plugin
export default {"modalContainer":"Iy","fadeRight":"Jy","fadeUp":"Ky","topShelf":"Ly","newFlavorBadge":"My","transparentText":"Ny","cancelButton":"Oy","invisibleLink":"Py","closeIcon":"Qy","linkContainer":"Ry","hed":"Sy","image":"Ty"};
    if(module.hot) {
      // 1737143654601
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  